import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'ok' | 'warn' | 'danger' | 'accent';

const TONE_CLASS: Record<BadgeTone, string> = {
  neutral: 'badge',
  ok: 'badge badge-ok',
  warn: 'badge badge-warn',
  danger: 'badge badge-danger',
  accent: 'badge badge-accent',
};

export function Badge({
  tone = 'neutral',
  dot = false,
  children,
}: {
  tone?: BadgeTone;
  dot?: boolean;
  children: ReactNode;
}) {
  return (
    <span className={TONE_CLASS[tone]}>
      {dot && <span className="badge-dot" />}
      {children}
    </span>
  );
}
